import { RefObject, useEffect } from 'react';

interface UseOutsideClickProps {
  ref: RefObject<HTMLElement>;
  cb: () => void;
  isOpen: boolean;
}

export function useOutsideClick({
  ref,
  cb,
  isOpen,
}: UseOutsideClickProps): void {
  useEffect(() => {
    const el = ref?.current;

    if (!el || !isOpen) return;

    const clickHandler = ({ target }: MouseEvent): void => {
      if (target !== el && !el.contains(target as Node)) {
        cb();
      }
    };

    window.document.addEventListener('click', clickHandler);

    return () => window.document.removeEventListener('click', clickHandler);
  }, [cb, ref, isOpen]);
}
